<template>
  <el-container >
    <el-header >
<!--        <top-header @title-search="toChildMsg"/>-->
        <video-header @title-search="toChildMsg"/>
    </el-header>
    <el-main>
      <div class="rule" v-html="content"></div>
    </el-main>
    <el-footer>
      <app-footer/>
    </el-footer>
  </el-container>
</template>

<script>


  import {TopHeader,AppFooter,VideoHeader} from '@/layout/components'
  import 'element-ui/lib/theme-chalk/index.css';
export default {
  name: "index",
  components: {TopHeader,AppFooter,VideoHeader},
  data(){
    return{
      titleSearch:null,
      content:'<p style="text-align: center;"><span style="font-size: 18pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;"><strong>百驿学院相关规则</strong></span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;"><strong>&nbsp;</strong></span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;"><strong>一、内容规则</strong></span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">1、百驿学院上的内容是指您在百驿学院上传的视频、文档形式的内容，包括但不限于运输、仓储、配送、物流信息化、物流政策、物流资讯、园区智能化、物流供应链等物流相关的内容。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">2、您在百驿学院上传或发布的作品，您保证对其享有合法的著作权或相应授权，百驿学院有权展示、散布及推广前述内容。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">3、任何经由百驿学院提供的服务，以上传、张贴或任何其他方式传送的资讯、资料、文字、照片、图形、视讯、信息或其他资料（以下简称&ldquo;内容&rdquo;），无论系公开还是私下传送，均由内容提供者、上传者承担责任。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">4、百驿学院无法预先知晓并合理控制经由百驿学院服务上传之内容，因此，您已预知在使用百驿学院的服务时，可能会接触到部分令您感到不快、不适或厌恶的内容，您同意放弃由此产生的针对百驿学院的任何追索权。但百驿学院有权依法停止传输任何前述内容并采取相应处理，包括但不限于暂停您继续使用百驿学院的部分或全部服务，保存有关记录并向有关机关报告。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">5、您需独立对自己在百驿学院上实施的行为承担法律责任。若您使用百驿学院服务的行为不符合本协议，百驿学院有权作出独立处理，且在无需事先通知或征得用户同意的情况下停用您的账号。您若在百驿学院上散布和传播反动、色情或其他违反国家法律、规定的信息，百驿学院的系统记录可能作为您违反相关法律的证据。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">6、百驿学院严格遵守我国政府颁布的《互联网信息服务管理办法》第十五条规定，并将此作为百驿学院平台的运行基本准则；对于含有以下内容的信息，我们将采用最严格的管理方法，予以杜绝：</span></p>\n' +
        '<ul>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">反对宪法所确定的基本原则的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">损害国家荣誉和利益的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">煽动民族仇恨、民族歧视，破坏民族团结的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">破坏国家宗教政策，宣扬邪教和封建迷信的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">散布谣言，扰乱社会秩序，破坏社会稳定的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">散步污秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">侮辱或者诽谤他人，侵害他们合法权益的；</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">含有法律、行政法规禁止的其他内容的；</span></li>\n' +
        '</ul>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">7、违禁内容：</span></p>\n' +
        '<ul>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">关于裸露和色情内容</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">关于暴力、有危害性或者危险性内容</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">关于危害个人隐私</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">与物流无关内容及违反国家法律法规的垃圾内容</span></li>\n' +
        '</ul>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;"><strong>二、使用规则</strong></span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">1、用户在使用百驿学院服务的过程中，应遵守以下法律法规：</span></p>\n' +
        '<ul>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">《中华人民共和国保守国家秘密法》</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">《中华人民共和国著作权法》</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">《中华人民共和国计算机信息系统安全保护条例》</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">《计算机软件保护条例》</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">《互联网电子公告服务管理规定》</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">《信息网络传播权保护条例》</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">《中华人民共和国网络安全法》</span></li>\n' +
        '<li><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">其他有关计算机及互联网规定的法律、法规。</span></li>\n' +
        '</ul>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">2、在任何情况下，百驿学院一旦合理地认为用户的行为可能违反上述法律、法规，可以在任何时候，不经事先通知终止向该用户提供服务。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">3、如用户提供的上传内容含有以上违反政策法律法规的信息或者内容的，由用户直接承担以上导致的一切不利后果，如因此给百驿学院造成不利后果的，用户应负责消除影响，并且赔偿因此导致的一切损失。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;"><strong>三、积分规则</strong></span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">1、如用户提供的上传内容含有视频和文档，用户可选择作品是否免费。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">2、上传一篇文稿用户可获得3积分。</span></p>\n' +
        '<p><span style="font-size: 12pt; font-family: \'Microsoft YaHei\', \'Helvetica Neue\', \'PingFang SC\', sans-serif;">3、免费文稿用户可免费查看，积分文稿需消费10积分。</span></p>'
    }
  },
  methods:{
    toChildMsg(title){
      this.titleSearch=title
    }
  }
}
</script>

<style scoped>
   .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
  }
  .el-header{
    background-color: white;
    color: #333;
    text-align: center;
    height: 50px;
    position: fixed;
    width: 100%;
    z-index: 999;
    top: 0;
  }
  .el-footer{
    position: relative;
    padding: 0px;
    text-align: left;
  }
  .el-main {
    /*background-color: #E9EEF3;*/
    font-family: "微软雅黑 Light" !important;
    font-weight: 500;
    color: #333;
    text-align: none;
    position: relative;
    margin-top: 50px;
    padding: 0px;
  }
  .rule{
    padding-top: 80px;
    width: 1000px;
    margin: auto;
  }


  body > .el-container {
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/filerule/index.vue